import { z } from 'zod'
import { oc } from '@orpc/contract'

export const visitJoinLinkResponseSchema = z.object({
  // The patient's join link for this visit — the same link the email/SMS carries.
  link: z.string(),
  // Instant the link expires (ISO-8601).
  expiresAt: z.string(),
})
export type VisitJoinLinkResponse = z.infer<typeof visitJoinLinkResponseSchema>

/**
 * Mint the patient's join link for a visit WITHOUT sending it, so staff can hand it over on a
 * channel of their own (PD-1873). Refused for cancelled, no-show, completed or past visits —
 * the overlay's send-code has no such gate. The link lives until an hour past the visit's end.
 */
export const visitJoinLinkCreate = oc
  .route({ method: 'POST', path: '/v2/visits/{encounterId}/join-link' })
  .input(z.object({ encounterId: z.string().min(1) }))
  .output(visitJoinLinkResponseSchema)
